module.exports = __webpack_public_path__ + "static/img/o2.dc6b313.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/owl/o2.jpg
// module id = GUMB
// module chunks = 0